import { render } from "./CustomPlanGenerator.vue?vue&type=template&id=35463153&scoped=true"
import script from "./CustomPlanGenerator.vue?vue&type=script&lang=js"
export * from "./CustomPlanGenerator.vue?vue&type=script&lang=js"

import "./CustomPlanGenerator.vue?vue&type=style&index=0&id=35463153&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35463153"]])

export default __exports__